import {
  Directive,
  ElementRef,
  Input
} from '@angular/core'

@Directive({
  selector: '[mbFocus]'
})
export class MbFocusDirective {

  @Input() set mbFocus (isFocus: boolean) {
    if (isFocus) {
      this.host.nativeElement.focus()
    }
  }

  constructor (private host: ElementRef) { }
}
